import { render, staticRenderFns } from "./Home2.vue?vue&type=template&id=0234e3a2&scoped=true"
import script from "./Home2.vue?vue&type=script&lang=js"
export * from "./Home2.vue?vue&type=script&lang=js"
import style0 from "./Home2.vue?vue&type=style&index=0&id=0234e3a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0234e3a2",
  null
  
)

export default component.exports